












import { State } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'

@Component
class App extends Vue {
  @State(state => state.error.message) errorMessage!: string | null
  @State(state => state.error.subMessage) subErrorMessage!: string | null

  defaultMessage = '网络异常'
}

export default App
